var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group Copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Address-Book",
    transform: "translate(-781.000000, -187.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-3",
    transform: "translate(781.160000, 187.573870)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-6",
    fill: "#E9E9E0",
    cx: 15.5,
    cy: 15.5,
    r: 15.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2164152,10.3951489 C19.68955,9.8682837 18.8384601,9.8682837 18.3114598,10.3951489 L11.3812909,17.3119435 C11.3542722,17.3388271 11.3407628,17.3524716 11.3272534,17.3794903 C11.3272534,17.3794903 11.3272534,17.3929997 11.3137441,17.3929997 C11.3002347,17.4200184 11.2867253,17.4335278 11.2867253,17.4605465 L11.2867253,17.4739208 L10.3680886,20.4731348 C10.3275605,20.6217378 10.3680886,20.7703408 10.4626541,20.8784157 C10.5437103,20.9594719 10.6382758,21 10.7463508,21 C10.7868789,21 10.827407,21 10.867935,20.9863555 L13.8535046,20.0678539 L13.867014,20.0678539 C13.8940327,20.0543445 13.9210514,20.0543445 13.9345608,20.0407 C13.9345608,20.0407 13.9480701,20.0407 13.9480701,20.0273258 C13.9750889,20.0138164 14.0021076,20.000307 14.015617,19.9731532 L20.9324116,13.0564937 C21.4592768,12.5296285 21.4592768,11.6785385 20.9324116,11.1516733 L20.2164152,10.3951489 Z",
    id: "Fill-1",
    fill: "#A7A794"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIc);
export default __webpack_public_path__ + "static/media/edit-ic.af65221c2ab4a8a1197d9c2af7f4eb47.svg";
export { ForwardRef as ReactComponent };